import React, { useEffect, useState, useRef } from 'react';


function Video(props) {

    const [ fullClip, setFullClip ] = useState([ 50, 50 ]); //[ 50-0  , 50 - 100]
    const [ foldClipArray, setFoldClipArray ] = useState([ 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50 ])
    const [ foldClipStr, setFoldClipStr ] = useState("");
    const [ direction, setDirection ] = useState(null);
    const video = useRef(null);

    const { mediaRef} = props

    useEffect(() => {

        setRandomClip();
        video.current.setAttribute('playsinline','')
       

        setDirection(props.direction)
        mediaRef(video.current)

    }, [])

    setTimeout(() => {
        video.current.setAttribute('autoPlay','')
    }, 300);

    //IF DIRECTION IS DOWN

    useEffect(() => {
        if (props.down === direction) {
            handleFader()
        } else {
            setFullClip([ 50, 50 ])
        }
    }, [ props, direction ])

    useEffect(() => {
        setDirection(props.direction);
    }, [ props.direction ]);

    function handleFader() {

        setFullClip([ clipMapper(50, 0, 2), clipMapper(50, 100, 2) ])

        const dest0 = [ 0, 1, 3, 5, 12, 14 ];
        const dest50 = [ 2, 7, 10, 15 ];
        const dest100 = [ 4, 6, 8, 9, 11, 13 ];
        let newClipArr = [];

        foldClipArray.forEach((int, index) => {
            if (dest0.includes(index)) {
                newClipArr.push(clipMapper(int, 0, 1));
            }
            if (dest50.includes(index)) {
                newClipArr.push(clipMapper(int, 50, 1));
            }
            if (dest100.includes(index)) {
                newClipArr.push(clipMapper(int, 100, 1));
            }
        })
        clipArrayToStr(newClipArr);

        function clipMapper(start, dest, multiplier) {
            let result;
            result = (dest - start) * ((-props.fader * direction) * multiplier) + start;
            return result;
        }
    }

    function setRandomClip() {
        let newArr = foldClipArray.map(() => Math.round(Math.random() * 100));
        setFoldClipArray(newArr);
        clipArrayToStr(newArr);
    }

    function clipArrayToStr(arr) {

        let newClipStr = "";
        arr.forEach((int, i) => {
            const addToStr = i % 2 === 0 ? `${int}% ` : `${int}%,`;
            newClipStr += addToStr;
        })
        const parsedString = newClipStr.slice(0, -1);
        setFoldClipStr(parsedString);

    }

    useEffect(() => {
        if (video && direction === props.down) {
            Math.abs(props.fader) > 0 ? video.current.play() : video.current.pause();
            video.current.volume = Math.abs(props.fader) <= props.volumeControl ? Math.abs(props.fader) : props.volumeControl;
        } else if (video && direction !== props.down) {
            video.current.volume = 0;
            video.current.pause();
        }

    }, [ props.fader ]);

    // polygon (left 0% - 100% , top 0% 
    //                               - 

    //                              100%)

    return (
        <div
            className="fold"
            style={
                {
                    clipPath: `polygon(0% 0%, 50% ${fullClip[ 0 ]}%, 100% 0%, ${fullClip[ 1 ]}% 50%, 100% 100%, 50% ${fullClip[ 1 ]}%, 0% 100%, ${fullClip[ 0 ]}% 50%)`,
                    ...props.style
                }
            }

        >
            <video 
                ref={video}
                style={{
                    clipPath: `polygon(${foldClipStr})`,
                    width: '100%',
                }}
                loop
            >
                <source src={`${process.env.REACT_APP_API_URL}${props.url.url}`} type="video/mp4" />

            </video >

        </div>
    )
}

export default Video;
